import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import { reactive, onMounted } from 'vue'
import { orderStatusColumns } from "@/components/model/data";
import {downloadCbct, downLoadStl, getFaceImage, searchOralDiagnosis} from "@/api/order";
import { useRoute } from 'vue-router';
import { formatDateTime } from "@/components/ts/components";
import downloadFile from "@/components/ts/download";
import {downloadZip, ossToken} from "@/api/user";
import {message} from "ant-design-vue";
import {dE} from "@fullcalendar/core/internal-common";

export default /*#__PURE__*/_defineComponent({
  __name: 'detailTable',
  setup(__props) {

const columns = [
    {
        title: "序号",
        dataIndex: "key",
        key: "key",
        customRender: ({ index }: any) => `${index + 1}`,
    },
    {
        title: "创建时间",
        dataIndex: "creationDate",
        key: "creationDate",
        customRender: ({ record }: any) => {
            return record.creationDate ? formatDateTime(record.creationDate) : "";
        },
    },
    {
        title: "STL",
        dataIndex: "stlPath",
        key: "stlPath",
        // customRender: ({ record }: any) => {
        //     return record.stlPath ? "已上传" : "未上传";
        // },
    },
    {
        title: "CBCT",
        dataIndex: "ctPath",
        key: "ctPath",
        // customRender: ({ record }: any) => {
        //     return record.ctPath ? "已上传" : "未上传";
        // },
    },
    {
        title: "医学影像",
        dataIndex: "ct",
        key: "ct",
        // customRender: ({ record }: any) => {
        //     return record.ctPath ? "已上传" : "未上传";
        // },
    },
    {
        title: "流程状态",
        dataIndex: "reported",
        key: "reported",
        customRender: ({ record }: any) => orderStatusColumns[record.status]
    },
    {
        title: "被订单使用",
        dataIndex: "orderList",
        key: "orderList",
        customRender: ({ record }: any) => {
            let list = []
            if (record.oralOrthodonticOrderDesignId) {
                list.push('07')
            }
            console.log(list);
            return list.join(',')
        }
    },
]

const data = reactive({
    dataSource: [],
    pagination: {
        size: "small",
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total: string) => {
            return " 共" + total + "条";
        },
        hideOnSinglePage: false,
        showSizeChanger: true,
    },
    loading: false,
    //医学影像
    visible: false,
    ctPath: "",
    hasThirdPic: true
})
const route = useRoute();
onMounted(() => {
    search()
})

const changePageIndex = (page: any) => {
    data.pagination.pageSize = page.pageSize;
    data.pagination.current = page.current;
    search();
};

const search = () => {
    data.loading = true;
    let option = {
        page: {
            currPage: 1,
            pageSize: 100,
        },
        patientId: route.query.id,
    };
    searchOralDiagnosis(option).then((res: any) => {
        data.loading = false;
        data.dataSource = [];
        if (null !== res) {
            data.dataSource = res.data;
            data.pagination.total = res.records;
        }
    });
};

const downLoad = async (info: any, type: string) => {
    data.loading = true;
    await downloadFile.zip(info[type + 'Path'] + '/', type, type + '.zip', 'application/ZIP')
    data.loading = false;
};
const toCt = async (record: any)=>{
    let sts = await ossToken()
    let id = record.id;
    let patientId = record.patientId;
    data.ctPath = `https://${sts.bucket}.${sts.endpoint}/${patientId}/6/${id}/origin/ct/`;
    CheckImgExists(data.ctPath + '3.JPEG').then(()=>{
        data.hasThirdPic = true
    }).catch(()=>{
        data.hasThirdPic = false
    })
    data.visible = true;
}
function CheckImgExists (imgUrl: string) {
    return new Promise(function (resolve, reject) {
        const ImgObj = new Image();
        ImgObj.src = imgUrl;
        ImgObj.onload = (res) => {
            resolve(res);
        }
        ImgObj.onerror = (err) => {
            reject(err)
        }
    })
}
const handleCancel = (e: MouseEvent) => {
    console.log(e);
    data.ctPath = "";
    data.visible = false;
};
const handleOk = (e: MouseEvent) => {
    console.log(e);
    data.ctPath = "";
    data.visible = false;
};
const downLoadStlFile = async (info: any) => {
    data.loading = true;
    const res = await downLoadStl({"dir":info.stlPath})
    const content = res.data
    await zip(content,"stl.zip","application/octet-stream")
    data.loading = false;
};

const downloadCbctFile = async (info: any) => {
    data.loading = true;
    const res = await downloadCbct({"dir":info.stlPath})
    const content = res.data
    // 下载文件
    await zip(content,"CBCT.zip","application/octet-stream")
    data.loading = false;
};

const zip = async (content: any, filename: string, type: string): Promise<void> => {
    const blob = new Blob([content], {
        // 下载的文件格式自己在这边更改type的值就好了
        type
    })
    if (content.type === 'application/json') {
        const fileReader = new FileReader()
        fileReader.readAsText(blob,'utf-8')
        fileReader.onload = function () {
            let msg=JSON.parse(fileReader.result).errorMessage.msg;
            message.error(msg);
        }
        return
    }
    if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = filename
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
    }
}


return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_table, {
      dataSource: data.dataSource,
      loading: data.loading,
      scroll: { y: 400 },
      size: "small",
      columns: columns,
      bordered: "",
      pagination: data.pagination,
      onChange: changePageIndex
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'stlPath')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "javascript:;",
              onClick: ($event: any) => (downLoadStlFile(record))
            }, _toDisplayString(record.stlPath ? "下载" : "未上传"), 9, _hoisted_1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'ctPath')
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: "javascript:;",
              onClick: ($event: any) => (downloadCbctFile(record))
            }, _toDisplayString(record.stlPath ? "下载" : "未上传"), 9, _hoisted_2))
          : _createCommentVNode("", true),
        (column.dataIndex === 'ct')
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              href: "javascript:;",
              onClick: ($event: any) => (toCt(record))
            }, "查看", 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "loading", "pagination"]),
    _createVNode(_component_a_modal, {
      visible: data.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((data.visible) = $event)),
      title: "医学影像",
      onOk: handleOk,
      width: "40%",
      onCancel: handleCancel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_card, {
          bordered: false,
          style: {"text-align":"center"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, { size: 60 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_image, {
                  width: 200,
                  src: data.ctPath + 'Cephalometric.JPEG?x-oss-process=image/auto-orient,1/watermark,image_bG9nby5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF81MA,t_50,x_20,y_30\n'
                }, null, 8, ["src"]),
                _createVNode(_component_a_image, {
                  width: 200,
                  src: data.ctPath + 'Panoramic.JPEG?x-oss-process=image/auto-orient,1/watermark,image_bG9nby5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF81MA,t_50,x_20,y_30'
                }, null, 8, ["src"]),
                (data.hasThirdPic)
                  ? (_openBlock(), _createBlock(_component_a_image, {
                      key: 0,
                      width: 200,
                      src: data.ctPath + '3.JPEG?x-oss-process=image/auto-orient,1/watermark,image_bG9nby5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF81MA,t_50,x_20,y_30'
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})